import { type FunctionComponent } from 'react';

import styles from './SilverDot.module.scss';

export const SilverDot: FunctionComponent = () => (
  <div className={styles.silverDotContainer} />
);
